/**
 * Заглушки блюда и напитка без фото — как в приложении
 * (edim_app: assets/images/food.svg, drink.svg): серая иконка #C7C7CC на
 * половину квадратного кадра, поля прозрачные. Модификатор — пиала с ложкой
 * (edim_app: assets/images/modificator.svg) на половину кадра 105 : 60
 */
export const NO_PHOTO = {
  food: 'assets/no-photo-food.svg',
  drink: 'assets/no-photo-drink.svg',
  modificator: 'assets/no-photo-mod.svg',
} as const;

export type NoPhotoKind = keyof typeof NO_PHOTO;
